import { START } from 'pu-data/QuoteSteps';

import { USA_QUICKTURN_ID } from 'pu-data/ProductVariants';

import {
  rangeValidation,
  quantitiesValidation,
  panelizedValidation,
  hasArrayValidation,
  railWidthValidation,
} from 'pu-data/Validations';

import DefaultQuote              from './DefaultQuote'
import DefaultParameters         from './DefaultParameters';
import DefaultParametersCustomer from './DefaultParametersCustomer';
import DefaultParametersOffshore from './DefaultParametersOffshore';
import DefaultSuppliers          from './DefaultSuppliers';

const state = {
  name: 'PCB Fabrication',
  code: 'pcbfabrication',
  quote: DefaultQuote,
  loading: false,
  showSummary: false,
  itemSelected: false,
  boardConfirmSpecs: false,
  suppliers: DefaultSuppliers,
  variantId: USA_QUICKTURN_ID,
  sameBasicParams: false,

  parametersChanged: false,
  parameters: DefaultParameters,
  parametersBestPrice: DefaultParametersCustomer,
  parametersCustomer: DefaultParametersCustomer,
  parametersOffshore: DefaultParametersOffshore,

  // usGroups  : [],
  // usCombined: DefaultVendorCombined,
  errors: {},
  quoteStep: START,
};

export const validateParametersRules = {
  board_length: (name) => rangeValidation('Board Length', name, 0.1, 20),
  board_width: (name) => rangeValidation('Board Width', name, 0.1, 33),
};

export const aditionalRules = {
  quantities: quantitiesValidation,
  isPanelized: panelizedValidation,
  array_x: (parameters) => hasArrayValidation('Array X', 'array_x', parameters),
  array_y: (parameters) => hasArrayValidation('Array Y', 'array_y', parameters),
  array_up: (parameters) => hasArrayValidation('Array Up', 'array_up', parameters),
  array_x_qty: (parameters) => hasArrayValidation('Array X Qty', 'array_x_qty', parameters),
  array_y_qty: (parameters) => hasArrayValidation('Array Y Qty', 'array_y_qty', parameters),
  array_spacing_x: (parameters) => hasArrayValidation('Spacing in X', 'array_spacing_x', parameters),
  array_spacing_y: (parameters) => hasArrayValidation('Spacing in Y', 'array_spacing_y', parameters),
  railWidth: railWidthValidation,
};

export default state
